import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import './styles.scss'
const baseClass = 'donut-chart'

const d3 = Object.assign({}, require('d3-shape'), require('d3-scale'))

const translate = (x, y) => `translate(${x}, ${y})`

class Slice extends Component {
  static defaultProps = {
    visible: Function.prototype,
    move: Function.prototype,
  }

  static propTypes = {
    visible: PropTypes.func,
    move: PropTypes.func,
    name: PropTypes.string.isRequired,
  }
  state = {
    isHovered: false,
  }

  onMouseOver = () => {
    const { fill, name, percents, visible } = this.props
    this.setState({ isHovered: true })
    visible(fill, name, `${percents}%`)
  }

  onMouseOut = () => {
    this.setState({ isHovered: false })
    this.props.visible()
  }

  onMouseMove = ({ pageY, pageX }) => {
    this.props.move(pageY, pageX)
  }

  render() {
    let { value, percents, fill, innerRadius = 0, outerRadius, cornerRadius, padAngle } = this.props
    const { isHovered } = this.state

    if (isHovered) {
      outerRadius *= 1.1
    }

    let arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius)
      .cornerRadius(cornerRadius)
      .padAngle(padAngle)

    return (
      <g
        className={baseClass}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onMouseMove={this.onMouseMove}
      >
        <path d={arc(value)} fill={fill} />
        <text transform={translate(...arc.centroid(value))} dy=".15em" className={`${baseClass}__label`}>
          {/* we show percents only if there is enough space for the text */}
          {percents > 6 && `${percents}%`}
        </text>
      </g>
    )
  }
}

const Pie = ({ innerRadius, outerRadius, cornerRadius, name, padAngle, colors, x, y, data, visible, move }) => {
  const pie = d3.pie()

  const renderSlice = (value, i) => {
    return (
      <Slice
        key={i}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        cornerRadius={cornerRadius}
        padAngle={padAngle}
        value={value}
        percents={value.data}
        fill={colors[i].color}
        name={colors[i].name}
        visible={visible}
        move={move}
      />
    )
  }

  return <g transform={translate(x, y)}>{pie(data).map(renderSlice)}</g>
}

class Chart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      color: null,
      proTrackname: null,
      percents: null,
      top: null,
      left: null,
    }
  }
  handleVisibleChange = (color, proTrackname, percents) =>
    this.setState({
      visible: !this.state.visible,
      color,
      proTrackname,
      percents,
    })
  handleMove = (top, left) =>
    this.setState({
      top,
      left,
    })

  render() {
    const width = 220
    const height = 200
    const minViewportSize = Math.min(width, height)
    const radius = minViewportSize * 0.6 / 2
    const x = width / 2
    const y = height / 3
    const { data, colors } = this.props
    const { visible, color, proTrackname, percents, top, left } = this.state
    return (
      <Fragment>
        <svg width="130" height="130" viewBox="45 0 130 130">
          <Pie
            x={x}
            y={y}
            innerRadius={radius * 0.55}
            visible={this.handleVisibleChange}
            move={this.handleMove}
            outerRadius={radius}
            cornerRadius={0}
            padAngle={0}
            data={data}
            colors={colors}
          />
        </svg>
        {visible && (
          <div
            className={`${baseClass}__tooltip`}
            style={{
              position: 'absolute',
              top: `${top - 37}px`,
              left: `${left - 42}px`,
            }}
          >
            <span
              style={{
                backgroundColor: color,
              }}
              className={`${baseClass}__tooltip-color`}
            />
            <span className={`${baseClass}__tooltip-text`}>{proTrackname}</span>
            <span className={`${baseClass}__tooltip-percents`}>{percents}</span>
          </div>
        )}
      </Fragment>
    )
  }
}

export default Chart
